export default __webpack_public_path__ + "static/media/photo--sm--christina-4.e206f53f.jpg";